module.exports = __webpack_public_path__ + "createstatic/media/hotspot-icon.b45cf28b.svg";